import { PhysicalThing } from "./physicalThing";
import { deserializeXY } from "./serialization";
import type { XY } from "./xy";
import { ZOrder } from "./zOrder";

export class UnbreakableRock extends PhysicalThing {
	static key = "UnbreakableRock";
	constructor(xy: XY) {
		super(xy, true);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	static deserialize(data: any): UnbreakableRock {
		const rock = new UnbreakableRock(deserializeXY(data.xy));
		rock.visualId = data.visualId;
		return rock;
	}
}
